import React from 'react';
import useWhySiso from '../custom-hooks/useWhySiso';

function WhySiso (props) {
  const [whySiso, isLoading] = useWhySiso();
  if (isLoading === true) {
    return <p>Loading...</p>;
  }
return (
    <div id = "whySiso">
			<h1 id = "whyTitle" >WHY CHOOSE SISO</h1>
        {whySiso.map(whyResult => {
            console.log(whyResult);
      return (
            <div className="whyText" key={whyResult.fields.title}>
                {whyResult.fields.order > 1 && (
              <div className="whySplit">
                <h4 className="showSplit"> - </h4>
              </div>
            )}
                <p className="panelText">{whyResult.fields.description}</p>
            </div>
      )
    })} 
    </div>
)

}

export default WhySiso;
